import { api, formHeaders } from "@";
import type { LandingPageFormValues, SearchValues } from "../types";

export const getLandingPages = (
  page: number,
  perSize: number,
  search: Partial<SearchValues>,
) =>
  api.get(
    `/api/AdminLandingPage/landing-pages?page=${page}&perSize=${perSize}&name=${search.name || ""}&isPublished=${search.isPublished || ""}`,
  );

export const getLandingPage = (id: number | string) =>
  api.get(`/api/AdminLandingPage/landing-pages/${id}`);

export const checkSlugAvailability = (slug: string, excludeId?: number) =>
  api.get(`/api/AdminLandingPage/landing-pages/slug-available`, {
    params: { slug, excludeId },
  });

export const togglePublished = (id: number, value: boolean) =>
  api.put(
    `/api/AdminLandingPage/landing-pages/${id}/change-publish-status?isPublished=${value}`,
  );

export const saveLandingPage = (data: LandingPageFormValues) => {
  if (data.id) {
    return api.put(`/api/AdminLandingPage/landing-pages/${data.id}`, data);
  }
  return api.post("/api/AdminLandingPage/landing-pages", data);
};
